// src/components/Header.jsx
import React from 'react';

const Header = () => {
  return (
    <header className="bg-base-100 shadow-md py-4">

      <div className='mx-auto max-w lg:max-w-5xl px-4 '>

        <div className="mx-auto px-4 flex justify-between items-center">
          {/* Logo or Site Title */}
          {/* <div className="text-2xl font-bold text-primary">
            <a href="/">노트</a>
          </div> */}

          {/* Navigation Links (optional, based on the image structure) */}
          {/* The image primarily shows main sections below the header,
              but you might want nav links here. */}
          {/* <nav className="hidden md:flex space-x-4">
            <a href="#" className="text-base-content hover:text-primary">추천</a>
            <a href="#" className="text-base-content hover:text-primary">노트</a>
            </nav> */}

          {/* Action Button */}
          {/* <button className="btn btn-primary btn-sm md:btn-md">
            투고 신청
          </button> */}
        </div>

        <div className="px-4 py-5 bg-white">
          <h2 className="text-xl font-bold mb-4">이런 노트는 어떠신가요?</h2>

          <div className="flex flex-nowrap overflow-x-auto gap-2 pb-2">
            <button className="btn btn-sm bg-gray-900 text-white hover:bg-gray-800 whitespace-nowrap">컬쳐로도 안 나오는 마케팅 인사이트</button>
            <button className="btn btn-sm bg-gray-100 text-gray-700 hover:bg-gray-200 whitespace-nowrap">음악가들의 실제한 감정 만나보기</button>
            <button className="btn btn-sm bg-gray-100 text-gray-700 hover:bg-gray-200 whitespace-nowrap">가족·사람, 그 소중함을 말하는 이야기들</button>
          </div>

          <div className="mt-4 flex overflow-x-auto gap-3 pb-2">
            <div className="card card-compact min-w-[230px] bg-base-100 shadow-md">
              <figure className="h-28"><img src="https://placehold.co/230x112" alt="블랙&어브로드" className="w-full h-full object-cover" /></figure>
              <div className="card-body p-3">
                <p className="text-sm line-clamp-2 font-medium">블랙&어브로드 : 흑인을 위한 여행사, 차별을...</p>
              </div>
            </div>

            <div className="card card-compact min-w-[230px] bg-base-100 shadow-md">
              <figure className="h-28"><img src="https://placehold.co/230x112" alt="하인즈" className="w-full h-full object-cover" /></figure>
              <div className="card-body p-3">
                <p className="text-sm line-clamp-2 font-medium">하인즈 : 세계 1등 케첩 왕좌, '쓸까 마케팅'으로...</p>
              </div>
            </div>

            <div className="card card-compact min-w-[230px] bg-base-100 shadow-md">
              <figure className="h-28"><img src="https://placehold.co/230x112" alt="세스 고딘" className="w-full h-full object-cover" /></figure>
              <div className="card-body p-3">
                <p className="text-sm line-clamp-2 font-medium">세스 고딘 : 마케팅을 재정의한 경영 구루...</p>
              </div>
            </div>

            <div className="card card-compact min-w-[230px] bg-base-100 shadow-md">
              <figure className="h-28"><img src="https://placehold.co/230x112" alt="VOA" className="w-full h-full object-cover" /></figure>
              <div className="card-body p-3">
                <p className="text-sm line-clamp-2 font-medium">VOA : 가짜 대화도의 해석난, 172년 역할전환...</p>
              </div>
            </div>

            <div className="card card-compact min-w-[230px] bg-base-100 shadow-md">
              <figure className="h-28"><img src="https://placehold.co/230x112" alt="NASA" className="w-full h-full object-cover" /></figure>
              <div className="card-body p-3">
                <p className="text-sm line-clamp-2 font-medium">NASA 마케팅 : 우주 스트리밍 서비스와 로고...</p>
              </div>
            </div>
          </div>
        </div>

      </div>

    </header>
  );
};

export default Header;
